<template>
  <section class="video-module-component">
    <div class="inner-container">
      <h2
        class="title-section"
        v-html="data.title"></h2>
      <div class="content-section">
        <div
          class="left-col"
          v-html="data.left_text"></div>
        <div
          class="right-col"
          v-html="data.right_text"></div>
      </div>
      <div class="video-section">
        <div
          class="controls z-2 cursor-pointer opacity-0 transition-opacity duration-300
            ease-in-out"
          @mouseover="shouldShow(true)"
          @mouseleave="shouldShow(false)"
          @click="playVideo()">
          <img
            v-if="!playing"
            src="@/assets/img/play.svg"
            alt="play" />
          <img
            v-else
            src="@/assets/img/pause.svg"
            alt="pause" />
        </div>
        <svg
          v-if="playing"
          class="fullscreen"
          width="40px"
          height="40px"
          viewBox="0 0 32 32"
          fill="none"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          @click="requestFullscreen()">
          <path
            d="M4 12 L4 4 12 4 M20 4 L28 4 28 12 M4 20 L4 28 12 28 M28 20 L28 28 20 28" />
        </svg>
        <video
          ref="video"
          width="100%"
          class="z-1"
          playsinline>
          <source
            :src="data.video.url"
            type="video/mp4" />
          Your browser does not support HTML video.
        </video>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "VideoComponent",
  "CLASSNAME": "video-module-component",
  "URL": "http://vuevitewp.local/"
 }
#ENDMETA */

/*
 *   Insert your logic here
 */

import { onMounted, ref } from 'vue'

const video = ref(null)
const playing = ref(false)
const showButton = ref(true)
const playVideo = () => {
  if (playing.value) {
    video.value.pause()
    playing.value = false
  } else {
    video.value.play()
    playing.value = true
  }
}
const shouldShow = (hovering) => {
  if (hovering && playing.value) {
    showButton.value = true
  } else if (!hovering && playing.value) {
    showButton.value = false
  } else {
    showButton.value = true
  }
}

const requestFullscreen = () => {
  if (video.value.requestFullscreen) {
    video.value.requestFullscreen()
  } else if (video.value.webkitRequestFullscreen) {
    video.value.webkitRequestFullscreen()
  } else if (video.value.mozRequestFullScreen) {
    video.value.mozRequestFullScreen()
  } else if (video.value.msRequestFullscreen) {
    video.value.msRequestFullscreen()
  }
}

onMounted(() => {
  video.value.addEventListener('ended', () => {
    playing.value = false
  })
})

defineProps(['data'])
</script>

<style lang="scss">
.video-module-component {
  @apply py-20;
  .inner-container {
    @apply px-6 md:px-14 lg:px-6;
    .title-section {
      @apply header-4 mb-9 text-bicara-dark-blue;
    }
    .content-section {
      @apply pb-9;
      @apply flex flex-col gap-x-8 lg:flex-row;
      .left-col {
        @apply text-[22px] text-bicara-charcoal;
        p {
          @apply mb-4;
        }
      }
      .right-col {
        @apply text-[22px] text-bicara-charcoal;
        p {
          @apply mb-4;
        }
      }
    }
    .video-section {
      @apply relative;
      .controls {
        @apply absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform;
        @apply h-20 w-20 lg:h-32 lg:w-32;
        img {
          @apply absolute h-full w-full;
        }
      }
      .fullscreen {
        @apply absolute bottom-3 right-3 z-10 cursor-pointer opacity-0 transition-opacity duration-300 ease-in-out;
      }
      &:hover {
        .controls {
          @apply opacity-100;
        }
        .fullscreen {
          @apply opacity-100;
        }
      }
    }
  }
}
</style>
